function PageLoader() {
  return (
    <div className="page-loader" role="status" aria-live="polite">
      <span className="page-loader__bar" />
      <span className="sr-only">Cargando…</span>
    </div>
  );
}

export default PageLoader;
